/* eslint-disable */
import { CardGroup } from 'API';

// Card Group Queries
export const getCardGroupQuery = /* GraphQL */ `
  query getCardGroup($id: ID!, $cardLimit: Int = 100) {
    getCardGroup(id: $id) {
      __typename
      id
      paidolId
      name
      monthlyBudget {
        currency
        value
      }
      monthlyBudgetSpend {
        items {
          amount
          yearAndMonth
        }
      }
      groupAdmins {
        items {
          paidolUserId
          approvalLevels
          isReviewer
          id
          paidolUser {
            email
            user {
              id
              username
              email
              picture
              first_name
              last_name
            }
          }
        }
      }
      paymentCards(limit: $cardLimit) {
        nextToken
        items {
          paymentCardId
          paidolUsers(limit: 100) {
            items {
              id
              paidolUser {
                email
                user {
                  id
                  username
                  email
                  picture
                  first_name
                  last_name
                }
              }
            }
          }
        }
      }
      glCodeVisibilitySettings {
        isAllAvailable
        ids
      }
      projectVisibilitySettings {
        isAllAvailable
        ids
      }
    }
  }
`;

export type GetGroupsForPaidolIdQuery = {
  listCardGroupsByPaidolId?: {
    __typename: 'ModelCardGroupConnection';
    items: Array<CardGroup>;
    nextToken?: string | null;
  } | null;
};

export const GetGroupsForPaidolId = /* GraphQL */ `
  query GetGroupsForPaidolId($paidolId: ID!, $nextToken: String, $limit: Int = 100) {
    listCardGroupsByPaidolId(
      paidolId: $paidolId
      nextToken: $nextToken
      filter: { deletedAt: { attributeExists: false } }
    ) {
      nextToken
      items {
        id
        name
        createdAt
        updatedAt
        spendGroupId
        authPaidolId
        groupProjects
        isMonthlyBudgetUnlimited
        paymentCards(limit: $limit) {
          items {
            paymentCardId
            last4
            paidolUsers {
              items {
                paidolUser {
                  id
                  email
                  user {
                    id
                    first_name
                    last_name
                    picture
                  }
                }
              }
            }
          }
        }
        groupAdmins {
          items {
            paidolUserId
            approvalLevels
            isReviewer
            paidolUser {
              id
              email
              user {
                id
                first_name
                last_name
                picture
              }
            }
          }
        }
        monthlyBudget {
          currency
          value
        }
        monthlyBudgetSpend(sortDirection: DESC) {
          items {
            amount
            yearAndMonth
          }
        }
      }
    }
  }
`;

export type v2GetGroupsForPaidolIdQuery = {
  v2ListCardGroupsByPaidolId?: {
    __typename: 'v2ListCardGroupsByPaidolId';
    items: Array<CardGroup>;
    nextToken?: string | null;
    total: number;
  } | null;
};

export const v2GetGroupsForPaidolId = /* GraphQL */ `
  query v2ListCardGroupsByPaidolId(
    $paidolId: String!
    $nextToken: String
    $limit: Int = 100
    $sort: CardGroupSortInput
    $filter: CardGroupFilterInput
  ) {
    v2ListCardGroupsByPaidolId(
      input: {
        limit: $limit
        nextToken: $nextToken
        filter: { paidolId: { eq: $paidolId } }
        sort: $sort
        advancedFilter: $filter
      }
    ) {
      nextToken
      items {
        id
        name
        createdAt
        updatedAt
        spendGroupId
        authPaidolId
        groupProjects
        isMonthlyBudgetUnlimited
        paymentCards(limit: $limit) {
          items {
            paymentCardId
            last4
            paidolUsers {
              items {
                paidolUser {
                  id
                  email
                  user {
                    id
                    first_name
                    last_name
                    picture
                  }
                }
              }
            }
          }
        }
        groupAdmins {
          items {
            paidolUserId
            approvalLevels
            isReviewer
            paidolUser {
              id
              email
              user {
                id
                first_name
                last_name
                picture
              }
            }
          }
        }
        monthlyBudget {
          currency
          value
        }
        spentThisMonth {
          yearAndMonth
          amount
        }
        glCodeVisibilitySettings {
          isAllAvailable
          ids
        }
        projectVisibilitySettings {
          isAllAvailable
          ids
        }
      }
    }
  }
`;

//possibly obsolete
export const getMerchantSpendRule = /* GraphQL */ `
  query GetMerchantSpendRule($id: ID!) {
    getMerchantSpendRule(id: $id) {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      maximumAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      monthlyLimitAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listPaidolUserToCardGroups = /* GraphQL */ `
  query ListPaidolUserToCardGroups(
    $id: ID
    $filter: ModelPaidolUserToCardGroupFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPaidolUserToCardGroups(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        paidolId
        paidolUserId
        cardGroupId
        approvalLevels
        isReviewer
        paidolUser {
          id
          email
          user {
            id
            first_name
            last_name
          }
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
